/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'groupspush': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<defs><path pid="0" id="svgicon_groupspush_a" d="M0 0h20v20H0z"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_groupspush_b" _fill="#fff"><use xlink:href="#svgicon_groupspush_a"/></mask><g mask="url(#svgicon_groupspush_b)" _fill="#FFF"><path pid="1" d="M8.151 13.333l4.58 3.2c.2.14.46.19.69.12.24-.06.44-.23.54-.45l5.96-12.8a.83.83 0 00-.11-.88.856.856 0 00-.84-.28L.631 6.813c-.32.08-.56.35-.62.67-.05.33.09.65.36.84l4.64 3.08c.79.53 1.81.56 2.64.08l4.6-2.68a.828.828 0 000-1.44.84.84 0 00-.84 0l-4.6 2.68c-.27.16-.62.15-.88-.03l-3.06-2.03 14.8-3.7-4.8 10.32-3.77-2.63a.835.835 0 00-1.16.21c-.26.37-.17.89.21 1.15z"/><path pid="2" d="M6.67 14.02a.84.84 0 00-.42-.72.822.822 0 00-.83 0 .84.84 0 00-.42.72v3.2c0 .35.21.65.53.78.32.12.68.04.91-.21l3-3.2c.31-.33.3-.86-.04-1.17a.824.824 0 00-1.17.03l-1.56 1.67v-1.1z"/></g></g>'
  }
})
